import { IS_TO_REDIRECT_SESSION_EXPIRED } from 'gatsby-env-variables'

import { showFeedback } from '@itau-loans-www/hooks'

import messageDictionary from './messageDictionary'
import redirectTryAgain from './redirectTryAgain'

const helpers = {
  matchWithEndpoint: (url, endpoint) => {
    const urlValues = url.split('/')
    return urlValues.some((item) => item === endpoint)
  }
}

export default (error) => {
  const errorResponse = error?.response
  const errorStatus = errorResponse?.status
  const errorMessage = errorResponse?.data?.message
  const errorEndpoint = errorResponse?.config?.url
  const errorMethod = errorResponse?.config?.method

  const fgtsWithEmptyProposal =
    errorStatus === 404 && helpers.matchWithEndpoint(errorEndpoint, 'proposals')

  const fgtsNotAllowed =
    [404, 422].includes(errorStatus) &&
    helpers.matchWithEndpoint(errorEndpoint, 'fgts-allowed') &&
    errorMethod === 'get'

  const exceptions = [fgtsNotAllowed, fgtsWithEmptyProposal]

  const hasExceptions = exceptions.some((exception) => exception === true)
  const isInvalidTokenMessage = /Invalid token/.test(errorMessage)

  if (!hasExceptions) {
    const commonCases = messageDictionary[errorMessage] ?? errorMessage

    const feedbackMessage = isInvalidTokenMessage
      ? messageDictionary['invalid or expired jwt']
      : commonCases

    showFeedback({
      detail: {
        message: feedbackMessage,
        show: true,
        type: 'error'
      }
    })
  }

  const proposalAlreadyFinished =
    errorMessage ===
    '422: Não é possível alterar os dados do seu pedido, ele já está concluído.'

  const invalidOrExpiredAuth = errorMessage === 'invalid or expired jwt'

  const hasUndefinedAtEndpoint = /undefined/.test(errorEndpoint)

  if (
    (invalidOrExpiredAuth ||
      proposalAlreadyFinished ||
      hasUndefinedAtEndpoint ||
      isInvalidTokenMessage) &&
    IS_TO_REDIRECT_SESSION_EXPIRED
  ) {
    redirectTryAgain()
  }

  return Promise.reject(new Error(error))
}
